export default defineNuxtRouteMiddleware(() => {
  // This check ensures the code runs only on the client-side
  if (process.client) {
    // Access the window object directly to check screen width
    const screenWidth = window.innerWidth

    // Tailwind's 'md' breakpoint is typically 768px
    if (screenWidth < 768) {
      // Navigate to the specified route if the screen width is less than 'md'
      return navigateTo('/dashboard/account/admin/')
    }
  }
})
